import React, { useMemo } from 'react';
import './SlotSelectOverlay.css';
import { getSlotImg, getSlotName } from '../../core/buildUtils';
import MediaImg from '../utils/MediaImg';

const EMPTY_ICON_FALLBACK = '/img/stat_re_armes.png';
const GRID_CLASS_BY_COUNT = {
    2: 'slot-select-grid--2',
    6: 'slot-select-grid--6'
};
const LABEL_SEPARATOR = ' ';
const INDEX_OFFSET = 1;

const getGridClass = (slotCount) => GRID_CLASS_BY_COUNT[slotCount] || GRID_CLASS_BY_COUNT[6];

const getSlotLabel = (slotIds, slotId, index, lang) => {
    const baseLabel = getSlotName(slotId, lang);
    if (!baseLabel) return baseLabel;
    const isSameLabel = slotIds.every((id) => getSlotName(id, lang) === baseLabel);
    return isSameLabel ? `${baseLabel}${LABEL_SEPARATOR}${index + INDEX_OFFSET}` : baseLabel;
};

const SlotSelectOverlay = ({
    build,
    slotIds = [],
    lang = 'fr',
    onSelect,
}) => {
    const gridClass = useMemo(() => getGridClass(slotIds?.length || 0), [slotIds?.length]);

    return (
        <div className="slot-select-overlay column">
            <div className={`slot-select-grid ${gridClass}`}>
                {slotIds.map((slotId, index) => {
                    const item = build?.items?.[slotId];
                    const icon = item?.icon || getSlotImg(slotId) || EMPTY_ICON_FALLBACK;
                    const label = getSlotLabel(slotIds, slotId, index, lang);
                    return (
                        <button
                            key={`slot-select-${slotId}`}
                            type="button"
                            className={`slot-select-cell ${item ? 'occupied' : ''}`}
                            onClick={() => onSelect(slotId)}
                        >
                            {item?.icon ? (
                                <MediaImg className="slot-select-img" src={icon} alt={label} fill />
                            ) : (
                                <img className="slot-select-img" src={icon} alt={label} />
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default SlotSelectOverlay;
